export default __webpack_public_path__ + "static/media/ico-salir.7dabf241.svg";